module.exports = __webpack_public_path__ + "imgs/flowhub-icon.b78a0de64e8f4771497a5b2c5f332859.svg";